/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const Sex = {
    M: "m",
    F: "f",
};
export function SexFromJSON(json) {
    return SexFromJSONTyped(json, false);
}
export function SexFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function SexToJSON(value) {
    return value;
}
